const formatBytes = (bytes) => {
  const prefixes = [
    ["P", 2 ** 50],
    ["T", 2 ** 40],
    ["G", 2 ** 30],
    ["M", 2 ** 20],
    ["K", 2 ** 10]
  ];
  const maybePrefixAndDivisor = prefixes.find(([_prefix, divisor]) => bytes >= divisor);
  if (maybePrefixAndDivisor) {
    const [prefix, divisor] = maybePrefixAndDivisor;
    return `${(bytes / divisor).toPrecision(3)} ${prefix}iB`;
  }
  return `${bytes} B`;
};
const numberFormatter = new Intl.NumberFormat("en-US");
const formatNumber = (n) => numberFormatter.format(n);
const usdFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const formatUSD = (value) => {
  if (Number.isNaN(value)) {
    return "unknown";
  }
  if (value > 0 && value < 0.01) {
    return "< $0.01";
  }
  return usdFormatter.format(value);
};
export {
  formatBytes,
  formatNumber,
  formatUSD
};
